module.exports={"Star Rating":"Stjärnklassificering","# star(s)":"{currentRating, plural, =1{# stjärna} other{# stjärnor}}"};